import { c as _c } from "react/compiler-runtime";
import { EntityPlacementCtaTypeEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import { CTASearchParams } from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { Typography } from '@mui/material';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
type ReviewProductCardApplyNowTitleProps = {
  showCTA: boolean;
  thinTitle?: boolean;
};
export default function ReviewProductCardApplyNowTitle(t0) {
  const $ = _c(9);
  const {
    showCTA,
    thinTitle: t1
  } = t0;
  const thinTitle = t1 === undefined ? false : t1;
  const {
    marketplaceEntity
  } = useReviewContext();
  const {
    cta,
    ctaAnalytics,
    details: t2,
    displayName,
    finishType
  } = marketplaceEntity;
  const {
    applyLink
  } = t2;
  const variant = thinTitle ? "text" : "textBold";
  const isReview = cta.type === EntityPlacementCtaTypeEnum.ReadReview;
  let t3;
  if ($[0] !== applyLink || $[1] !== cta.type || $[2] !== ctaAnalytics || $[3] !== displayName || $[4] !== finishType || $[5] !== isReview || $[6] !== showCTA || $[7] !== variant) {
    t3 = showCTA ? <CtaLink analytics={{
      ...ctaAnalytics,
      section: {
        ...ctaAnalytics.section,
        name: "review_product_card"
      },
      linkType: "OFFER_NAME"
    }} isReview={isReview} type="OFFER_NAME" href={applyLink} rel={cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? "nofollow" : undefined} target="_blank" finishType={finishType} sx={{
      color: "inherit",
      textDecoration: "none"
    }} parameterActions={isReview ? [] : [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH]} data-testid="review-product-card-title"><Typography variant={variant} fontSize="bodyLarge.fontSize" position="relative" zIndex={1}>{displayName}</Typography></CtaLink> : <Typography variant={variant} data-testid="review-product-card-title">{displayName}</Typography>;
    $[0] = applyLink;
    $[1] = cta.type;
    $[2] = ctaAnalytics;
    $[3] = displayName;
    $[4] = finishType;
    $[5] = isReview;
    $[6] = showCTA;
    $[7] = variant;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}